import { lazyNamed } from 'src/utils/lazyNamed';

const PrintOperations = {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Print: lazyNamed(() => import('./containers/Print'), 'Print'),
  PublicationUpload: lazyNamed(() => import('./containers/PublicationUpload'), 'PublicationUpload'),
};

export default PrintOperations;
